"use client"

import { cn } from "@/lib/utils"
import type { ViewMode } from "@/lib/market-status/useViewMode"

export default function ViewToggle({ mode, onChange }: { mode: ViewMode; onChange: (mode: ViewMode) => void }) {
  return (
    <div className="flex items-center gap-0.5 rounded-md bg-zinc-800 p-0.5 text-xs">
      {(["chart", "table"] as const).map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => onChange(m)}
          className={cn(
            "rounded px-2 py-1 font-medium transition-colors",
            mode === m ? "bg-zinc-700 text-zinc-100" : "text-zinc-400 hover:text-zinc-200"
          )}
        >
          {m === "chart" ? "차트" : "테이블"}
        </button>
      ))}
    </div>
  )
}
